import axios from 'axios'
import store from '../../store'
// Define base url
const BASE_URL = '/api/v1/staff'

// Define staff module
const staff = {
  state: {
    data: {},
    errors: {}
  },
  getters: {
    getStaff: state => {
      return state.data
    },
    getStaffErrors: state => {
      return state.errors
    }
  },
  mutations: {
    setStaff (state, payload) {
      state.data = payload
    },
    setStaffErrors (state, payload) {
      state.errors = payload
    },
    destroyStaff (state, payload) {
      let index = state.data[payload.index].findIndex(i => i.id === payload.id)
      state.data[payload.index].splice(index, 1)
    }
  },
  actions: {
    async getStaff ({ commit }, payload) {
      try {
        const response = await axios.post(`${BASE_URL}/show`, payload)
        if (response.status === 200) {
          commit('setStaff', response.data.data)
        }
      } catch (error) {
        return error.response.data
      }
    },
    async storeStaff ({ commit }, payload) {
      try {
        const response = await axios.post(BASE_URL, payload)
        if (response.status === 201) {
          return response.data.data
        }
      } catch (error) {
        commit('setStaffErrors', error.response.data.errors)
      }
    },
    async updateStaff ({ commit }, payload) {
      try {
        const response = await axios.put(`${BASE_URL}/${payload.staff_id}`, payload)
        if (response.status === 202) {
          return response.data.data
        }
      } catch (error) {
        commit('setStaffErrors', error.response.data.errors)
      }
    },
    async destroyStaff ({ commit }, payload) {
      try {
        const response = await axios.delete(`${BASE_URL}/${payload}`, payload)
        if (response.status === 204) {
          return response.data
        }
      } catch (error) {
        commit('setStaffErrors', error.response.data)
        return error.response.data
      }
    }
  }
}

// Export the staff module
export default staff
